import { MdInsertEmoticon } from "react-icons/md";

import { Box } from "ui/box";
import { Typography } from "ui/typography";

import { TeamMember } from "types";

export const CommentDisplayByline = ({ user }: { user: Partial<TeamMember> }) => (
  <Box component="p" sx={{ py: "0.5rem", display: "flex", alignItems: "center" }}>
    <MdInsertEmoticon className="mr-2" data-testid="comment-display-byline-icon" />
    <Typography
      variant="inherit"
      component="span"
      data-testid="comment-display-byline-user-name"
      sx={{ fontWeight: 700, fontSize: "0.875rem" }}>
      {user.firstName} {user.lastName}
    </Typography>
  </Box>
);
